<template>
  <div class="current-board-page px-4 py-4 md:px-5">
    <div class="mx-auto space-y-5">
      <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div class="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
          <div>
            <p class="text-[15px] font-semibold text-slate-900">그룹 수업 현황판</p>
            <p class="mt-1 text-sm text-slate-500">유형, 시간, 언어, 레벨별 신청 현황과 마감 상태를 확인합니다.</p>
          </div>

          <div class="flex flex-wrap gap-2">
            <button
              type="button"
              @click="regist.handleComon()"
              :class="{ 'segment-button-active': regist.is_show_common }"
              class="segment-button"
            >
              일반
            </button>
            <button
              v-if="regist.isGroupSup == 'Y'"
              type="button"
              @click="regist.handleSupport()"
              :class="{ 'segment-button-active': regist.is_show_support }"
              class="segment-button"
            >
              지원
            </button>
          </div>
        </div>
      </section>

      <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div class="mb-4 flex flex-col gap-3 border-b border-slate-200 pb-4 md:flex-row md:items-center md:justify-between">
          <div>
            <p class="text-base font-semibold text-slate-900">그룹 유형</p>
            <p class="mt-1 text-sm text-slate-500">조회할 그룹 유형을 선택하세요.</p>
          </div>
          <button type="button" class="secondary-outline-button" @click="regist.handleLevelCheck()">신청 레벨 확인</button>
        </div>
        <ul class="selection-list">
          <li
            v-for="groupTypeInfo in regist.sugangInfo.sugangGroupTypeList"
            :key="groupTypeInfo.idxLeSugangGroupType"
            class="selection-chip"
            :class="{ 'selection-chip-active': regist.selectedGroupType === groupTypeInfo.groupType }"
            @click="regist.handleSugangLang(groupTypeInfo)"
          >
            {{ groupTypeInfo.groupType }}
          </li>
        </ul>
      </section>

      <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div class="mb-4 border-b border-slate-200 pb-4">
          <p class="text-base font-semibold text-slate-900">시간</p>
          <p class="mt-1 text-sm text-slate-500">수업 시간을 선택하세요.</p>
        </div>
        <ul class="selection-list">
          <li
            v-for="groupTimeInfo in regist.sugangInfo.sugangGroupTimeInfoList"
            :key="groupTimeInfo.idxLeSugangGroupTimeInfo"
            class="selection-chip"
            :class="{ 'selection-chip-active': regist.selectedGroupTimeValue === `${groupTimeInfo.numberOfClass}-${groupTimeInfo.lessonTime}` }"
            @click="regist.updateTime(groupTimeInfo)"
          >
            주{{ groupTimeInfo.numberOfClass }}회 {{ groupTimeInfo.lessonTime }}분
          </li>
        </ul>
      </section>

      <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div class="mb-4 border-b border-slate-200 pb-4">
          <p class="text-base font-semibold text-slate-900">언어</p>
          <p class="mt-1 text-sm text-slate-500">언어를 선택하세요.</p>
        </div>
        <ul class="selection-list">
          <li
            v-for="languageInfo in regist.selectedLangList"
            :key="languageInfo.idxLeSugangGroupLang"
            class="selection-chip"
            :class="{ 'selection-chip-active': regist.selectedGroupTimeLanguage === languageInfo.language }"
            @click="regist.updateLanguageLevels(languageInfo)"
          >
            {{ languageInfo.language }}
          </li>
        </ul>
      </section>

      <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div class="mb-4 border-b border-slate-200 pb-4">
          <p class="text-base font-semibold text-slate-900">레벨</p>
          <p class="mt-1 text-sm text-slate-500">레벨을 선택하면 상세 방 현황을 조회합니다.</p>
        </div>
        <ul class="selection-list overflow-auto">
          <li
            v-for="levelInfo in regist.selectedLanguageLevels"
            :key="levelInfo.idxLeSugangGroupLevel"
            class="selection-chip"
            :class="{ 'selection-chip-active': regist.selectedGroupTimeLanguageLevel === levelInfo.levelName }"
            @click="regist.sugangGroupDetailRoom(levelInfo)"
          >
            {{ levelInfo.levelName }}
          </li>
        </ul>
      </section>

      <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div class="mb-4 border-b border-slate-200 pb-4">
          <p class="text-base font-semibold text-slate-900">그룹 시간 테이블</p>
          <p class="mt-1 text-sm text-slate-500">셀을 클릭하면 해당 마감 페이지로 이동합니다.</p>
        </div>
        <div class="table-group-class-tbody table-scroll-wrap rounded-xl border border-slate-200">
          <table>
            <tbody v-if="regist.sugangGroupDetailRoomClassList.length > 0">
              <tr>
                <!-- 과정/시간대 헤더 -->
                <th class="sticky-col" rowspan="2">과정/시간대</th>
                <!-- 시간대 헤더 -->
                <th
                  v-for="(timeInfo, index) in regist.sugangGroupDetailRoomClassList[0]?.timeList"
                  :key="'time-header-' + index"
                  class="board-head-cell"
                  :colspan="regist.maxTimeInfoListLength * 2"
                >
                  {{ timeInfo.time }} ~ {{ regist.calculateEndTime(timeInfo.time) }}
                </th>
              </tr>
              <tr>
                <!-- 주간 시간 헤더 -->
                <th v-for="(weekInfo, index) in regist.getAllWeekTimes()" :key="'week-header-' + index" colspan="2">
                  {{ weekInfo }}
                </th>
              </tr>
              <tr v-for="classInfo in regist.sugangGroupDetailRoomClassList" :key="classInfo.className">
                <td class="sticky-col">{{ classInfo.className }}</td>
                <template v-for="(timeInfo, timeIndex) in classInfo.timeList" :key="timeIndex">
                  <template v-for="(weekInfo, weekIndex) in timeInfo.timeInfoList" :key="weekIndex">
                    <td colspan="2">
                      <ul>
                        <li class="status-stack">
                          <p
                            class="status-button status-button-green"
                            @click="regist.goToEnrolmentClosed(classInfo, timeInfo.time, weekInfo)"
                          >
                            총 {{ weekInfo.totalCount }}개
                          </p>
                          <p class="status-button status-button-red">
                            마감 {{ weekInfo.closeCount }}개
                          </p>
                          <p class="status-button status-button-blue">
                            신청가능 {{ weekInfo.openCount }}개
                          </p>
                        </li>
                      </ul>
                    </td>
                  </template>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </div>

  <!-- 신청 레벨 확인 팝업 -->
  <div v-if="regist.is_ShowLevelPop">
    <div class="fixed inset-0 z-[10] h-full w-full overflow-y-auto bg-black/80">
      <div class="mx-auto flex w-full max-w-[960px] flex-col items-center justify-center p-5">
        <div class="flex w-full justify-end rounded-t-2xl border border-slate-200 border-b-0 bg-white p-4">
          <p class="cursor-pointer text-base font-bold text-slate-700 underline" @click="regist.handleCloseLevelCheck()">닫기</p>
        </div>
        <div class="w-full overflow-hidden rounded-b-2xl border border-slate-200 bg-white p-4">
          <img src="@/assets/images/levelcheck.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
import axios from "@/plugins/axios.js";

export default {
  setup() {
    const router = useRouter();
    const route = useRoute();

    const { idxLeSugang } = route.query;

    const regist = reactive({
      is_ShowLevelPop: false,

      isGroupSup: "",
      is_show_common: true,
      is_show_support: false,

      sugangInfo: {
        sugangGroupTypeList: [],
        sugangGroupTimeInfoList: [],
        sugangGroupLangList: [],
        sugangGroupLevelList: [],
        selectedLangList: [],
      },

      sugangSupType: "",

      selectedGroupType: "", // 선택된 그룹 유형
      selectedGroupTime: "", // 선택된 시간
      selectedGroupTimeValue: "", // 선택된 시간 값
      selectedGroupTimeLanguage: "", // 선택된 언어

      selectedGroupTimeLanguageIdxLeSugangGroupLevel: 0, // 선택된 레벨 그룹 인덱스
      selectedGroupTimeLanguageLevel: "", // 선택된 레벨

      maxTimeInfoListLength: 0,
      sugangGroupDetailRoomClassList: [],

      // 수강 홈페이지 조회
      // getSugangHomePage() {
      //   const params = {
      //     idxLeSugang: route.query.idxLeSugang,
      //     sugangSupType: regist.sugangSupType,
      //   };

      //   axios.get(`/admin/sugangGroupDetail`, { params }).then(function (res) {
      //     if (res.data.success) {
      //       if (regist.sugangSupType == "일반") {
      //         regist.sugangInfo = res.data.data[0];
      //       } else {
      //         regist.sugangInfo = res.data.data[1];
      //       }
      //     } else {
      //       // 처리 실패 시의 동작
      //     }
      //   });
      // },

      getSugangHomePage() {
        const params = {
          idxLeSugang: route.query.idxLeSugang,
          sugangSupType: regist.sugangSupType,
        };

        axios
          .get(`/admin/sugangGroupDetail`, { params })
          .then(function (res) {
            if (res.data.success) {
              if (res.data.data.length > 0) {
                // 데이터가 있는지 확인
                if (regist.sugangSupType === "일반" || regist.sugangSupType === "지원") {
                  regist.sugangInfo = res.data.data[0];
                }
              } else {
                // 데이터가 없는 경우 처리
                alert("등록된 수업이 없습니다.");
              }
            } else {
              // 처리 실패 시의 동작
            }
          })
          .catch(function (error) {
            console.error("Error fetching data:", error);
            // 에러 처리
          });
      },

      getSugang() {
        const idxLeSugang = route.query.idxLeSugang;

        if (idxLeSugang && idxLeSugang !== "0") {
          const params = {
            idxLeSugang: idxLeSugang,
          };
          axios.get("/admin/sugang", { params }).then(function (res) {
            if (res.data.success) {
              regist.isGroupSup = res.data.data.sugangInfo.isGroupSup;
            } else {
              // 처리 실패 로직
            }
          });
        }
      },

      handleLevelCheck() {
        regist.is_ShowLevelPop = true;
      },

      handleCloseLevelCheck() {
        regist.is_ShowLevelPop = false;
      },

      handleSugangLang(groupTypeInfo) {
        const { idxLeSugangGroupType, groupType } = groupTypeInfo;

        // 선택된 그룹 유형 설정
        this.selectedGroupType = groupType;

        const selectedGroup = regist.sugangInfo.sugangGroupTypeList.find(
          (group) => group.idxLeSugangGroupType === idxLeSugangGroupType
        );
        if (selectedGroup) {
          regist.sugangInfo.sugangGroupTimeInfoList = selectedGroup.sugangGroupTimeInfoList;
        }
      },

      updateTime(groupTimeInfo) {
        const { idxLeSugangGroupTimeInfo, numberOfClass, lessonTime } = groupTimeInfo;

        // 선택된 시간 설정
        regist.selectedGroupTime = `주${numberOfClass}회 ${lessonTime}분`;
        regist.selectedGroupTimeValue = `${numberOfClass}-${lessonTime}`;

        // 선택된 시간에 해당하는 언어 목록을 찾기
        const selectedTime = regist.sugangInfo.sugangGroupTimeInfoList.find(
          (time) => time.idxLeSugangGroupTimeInfo === idxLeSugangGroupTimeInfo
        );
        // 언어 목록이 존재하면
        if (selectedTime && selectedTime.sugangGroupLangList) {
          // 선택된 언어 목록을 설정
          regist.selectedLangList = selectedTime.sugangGroupLangList;
        } else {
          // 선택된 시간에 해당하는 언어 목록이 없으면 빈 배열로 설정
          regist.selectedLangList = [];
        }
      },

      updateLanguageLevels(languageInfo) {
        const { idxLeSugangGroupLang, language } = languageInfo;

        // 선택된 언어 설정
        regist.selectedGroupTimeLanguage = language;

        // 선택된 언어에 해당하는 레벨 목록을 찾기
        const selectedLanguage = regist.selectedLangList.find((lang) => lang.idxLeSugangGroupLang === idxLeSugangGroupLang);
        // 레벨 목록이 존재하면
        if (selectedLanguage && selectedLanguage.sugangGroupLevelList) {
          // 선택된 레벨 목록을 설정
          regist.selectedLanguageLevels = selectedLanguage.sugangGroupLevelList;
        } else {
          // 선택된 언어에 해당하는 레벨 목록이 없으면 빈 배열로 설정
          regist.selectedLanguageLevels = [];
        }
      },

      // 그룹 룸 상세 종료 시간 계산
      calculateEndTime(startTime) {
        const [hours, minutes] = startTime.split(":").map(Number);
        const newMinutes = (minutes + 30) % 60;
        let newHours = hours + Math.floor((minutes + 30) / 60);
        if (newHours === 24) newHours = 0;
        return `${newHours.toString().padStart(2, "0")}:${newMinutes.toString().padStart(2, "0")}`;
      },

      // 주간 시간 리스트 가져오기
      getAllWeekTimes() {
        return (
          regist.sugangGroupDetailRoomClassList[0]?.timeList
            .map((timeInfo) => timeInfo.timeInfoList.map((weekInfo) => weekInfo.weekTime))
            .flat() || []
        );
      },

      // 그룹 룸 상세 조회
      sugangGroupDetailRoom(levelInfo) {
        const { idxLeSugangGroupLevel, levelName } = levelInfo;

        // 선택된 레벨 설정
        regist.selectedGroupTimeLanguageIdxLeSugangGroupLevel = idxLeSugangGroupLevel;
        regist.selectedGroupTimeLanguageLevel = levelName;

        const params = {
          idxLeSugangGroupLevel: idxLeSugangGroupLevel,
        };

        axios.get(`/admin/sugangGroupDetailRoom`, { params }).then(function (res) {
          if (res.data.success) {
            const data = res.data.data.sugangGroupClassList;

            // 최대 TimeInfoList 길이 설정
            regist.maxTimeInfoListLength = Math.max(
              ...data.map((classInfo) => classInfo.timeList.map((timeInfo) => timeInfo.timeInfoList.length)).flat()
            );

            // 그룹 상세 방 정보 매핑
            regist.sugangGroupDetailRoomClassList = data;
          }
        });
      },

      // 그룹 수강신청 마감 페이지 이동
      goToEnrolmentClosed(classInfo, startTime, weekInfo) {
        const { idxLeSugangGroupClass, className } = classInfo;
        const timeInfo = `${startTime} ~ ${regist.calculateEndTime(startTime)}`;
        const { weekTime } = weekInfo;
        const {
          sugangSupType,
          selectedGroupType,
          selectedGroupTime,
          selectedGroupTimeLanguage,
          selectedGroupTimeLanguageIdxLeSugangGroupLevel,
          selectedGroupTimeLanguageLevel,
        } = regist;

        // 페이지 이동 파라미터 설정
        const params = new URLSearchParams();
        params.append("idxLeSugang", idxLeSugang);
        params.append("idxLeSugangGroupClass", idxLeSugangGroupClass);
        params.append("className", className);
        params.append("startTime", startTime);
        params.append("subType", sugangSupType);
        params.append("groupType", selectedGroupType);
        params.append("lessonTime", selectedGroupTime);
        params.append("language", selectedGroupTimeLanguage);
        params.append("idxLeSugangGroupLevel", selectedGroupTimeLanguageIdxLeSugangGroupLevel);
        params.append("level", selectedGroupTimeLanguageLevel);
        params.append("timeInfo", timeInfo);
        params.append("weekTime", weekTime);

        window.open(`${window.location.origin}/enrolmentClosed?${params.toString()}`, "_blank");
      },

      handleComon() {
        regist.is_show_common = true;
        regist.is_show_support = false;
        regist.sugangSupType = "일반";
        // regist.registSugangData.sugangOneLangList = registSugang.sugangOneLangListCommon;
        // registSugang.registSugangData.sugangOneTimeInfoList = registSugang.sugangOneTimeInfoListCommon;
        regist.getSugangHomePage();
      },

      handleSupport() {
        regist.is_show_common = false;
        regist.is_show_support = true;
        regist.sugangSupType = "지원";
        // registSugang.registSugangData.sugangOneLangList = registSugang.sugangOneLangListSupport;
        // registSugang.registSugangData.sugangOneTimeInfoList = registSugang.sugangOneTimeInfoListSupport;
        regist.getSugangHomePage();
      },
    });

    onMounted(() => {
      regist.getSugang();
    });

    return {
      regist,
    };
  },
};
</script>
<style scoped>
.current-board-page {
  min-height: 100%;
  background:
    radial-gradient(circle at top left, rgba(226, 232, 240, 0.65), transparent 32rem),
    linear-gradient(180deg, #f8fafc 0%, #ffffff 42%);
}

.segment-button {
  display: inline-flex;
  min-height: 2.75rem;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  border-radius: 0.85rem;
  background: #fff;
  padding: 0.65rem 1rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #334155;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;
}

.segment-button-active {
  border-color: #0f172a;
  background: #0f172a;
  color: #fff;
}

.secondary-outline-button {
  display: inline-flex;
  min-height: 2.75rem;
  align-items: center;
  justify-content: center;
  border: 1px solid #fecaca;
  border-radius: 0.85rem;
  background: #fff;
  padding: 0.65rem 1rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #dc2626;
}

.selection-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.selection-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  border-radius: 0.85rem;
  background: #fff;
  padding: 0.7rem 1rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #334155;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;
}

.selection-chip-active {
  border-color: #0f172a;
  background: #0f172a;
  color: #fff;
}

.table-scroll-wrap {
  max-height: calc(100vh - 260px);
  overflow: auto;
}

.table-group-class-tbody table {
  width: 100%;
  min-width: 1200px;
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;
}

.table-group-class-tbody tbody th,
.table-group-class-tbody tbody td {
  border-right: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  padding: 0.85rem 0.65rem;
  text-align: center;
}

.table-group-class-tbody tbody tr:first-child th,
.table-group-class-tbody tbody tr:first-child td {
  border-top: 1px solid #e2e8f0;
}

.table-group-class-tbody tbody th:first-child,
.table-group-class-tbody tbody td:first-child {
  border-left: 1px solid #e2e8f0;
}

.table-group-class-tbody tbody th {
  background: #f8fafc;
  font-size: 0.82rem;
  font-weight: 700;
  color: #334155;
  white-space: nowrap;
}

.table-group-class-tbody tbody td {
  background: #fff;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #334155;
  white-space: nowrap;
}

.table-group-class-tbody tbody tr:nth-child(even) td {
  background-color: #fbfdff;
}

.board-head-cell {
  background: #f8fafc;
  color: #334155;
}

.status-stack {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.status-button {
  display: inline-flex;
  min-height: 2.25rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  border: 1px solid currentColor;
  background: #fff;
  padding: 0.45rem 0.75rem;
  font-size: 0.88rem;
  font-weight: 700;
}

.status-button-green {
  color: #059669;
  cursor: pointer;
}

.status-button-red {
  color: #dc2626;
}

.status-button-blue {
  color: #2563eb;
}

/** 좌측 첫번째 열 헤더 */
.table-group-class-tbody tbody th.sticky-col {
  position: sticky;
  z-index: 4;
  left: 0;
  min-width: 140px;
  background: #f8fafc;
  background-clip: padding-box;
  box-shadow: 1px 0 0 #e2e8f0, 8px 0 16px rgba(15, 23, 42, 0.04);
}
/** 좌측 첫번째 열 헤더 */
.table-group-class-tbody tbody td.sticky-col {
  position: sticky;
  z-index: 3;
  left: 0;
  min-width: 140px;
  background-color: #fff;
  background-clip: padding-box;
  box-shadow: 1px 0 0 #e2e8f0, 8px 0 16px rgba(15, 23, 42, 0.04);
}

.table-group-class-tbody tbody tr:nth-child(even) td.sticky-col {
  background-color: #fbfdff;
}

@media (max-width: 1024px) {
  .table-group-class-tbody table {
    min-width: 1400px;
  }
}
</style>
